import React from 'react'

function Group() {
    return (
        <div>
            group page
        </div>
    )
}

export default Group;
